module.exports = __webpack_public_path__ + "img/Color 5.29a4d0f0.jpg";